// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"8000a9c2","727":"5f81e2db"}[chunkId] + ".chunk.js";
};